/* eslint-disable import/no-cycle */
import JWTDecode from 'jwt-decode';
import Axios from 'axios';
import Router from '@/router';
import Store from '@/store';
import api from '@/api';

let authenticated = true;
let decodedToken;

export default {

  async authenticate(options) {
    try {
      console.log('Authenticating...');

      let response;
      let token;

      // reauth
      if (!options) {
        console.log('With token...');

        token = this.getToken();

        if (!token) {
          this.logout();
          return false;
        }

        response = await api.auth.reauthenticate(token);
      } else response = await api.auth.authenticate(options.username, options.password);

      await this.onAuthentication(response);
      return true;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async onAuthentication(response) {
    console.log('Authenticated!');

    const token = response.data.jwt;
    authenticated = true;
    decodedToken = JWTDecode(response.data.jwt);

    localStorage.setItem('mision-portal-alumnos', token);
    Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    await Store.dispatch('session/getCurrentUser', decodedToken.uuid);
  },

  logout() {
    authenticated = false;
    localStorage.removeItem('userGrade');
    localStorage.removeItem('mision-portal-alumnos');
    localStorage.clear();
    Axios.defaults.headers.common.Authorization = null;
    Store.dispatch('session/removeCurrentUser');
    Router.push('/login');
  },

  isAuthenticated() {
    return authenticated;
  },

  getToken() {
    return localStorage.getItem('mision-portal-alumnos') || '';
  },

  getDecodedToken() {
    return decodedToken;
  },
};
